import { Component, input } from '@angular/core';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import type { FormControl } from '@angular/forms';

@Component({
  selector: 'cappus-filter-clear-button',
  imports: [MatIconButton, CustomMatSvgIconDirective, MatIcon],
  templateUrl: './filter-clear-button.component.html',
})
export class FilterClearButtonComponent {
  readonly control = input.required<FormControl>();
}
